export enum MarketBasketModalState {
  PREVIEW,
  ASSIGN,
  IMPORT,
  NEW_AND_ASSIGN,
  EDIT,
}
